import React, { useState, useEffect } from "react";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import AlertModal from "../../../Modal/AlertModal";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { exportJsonToExcelStyle } from "../../../../AdminApi/commFunc";

export default function UplusCombineWaitListDownloadModal({
  closeEvent,
}: DefaultModalCommonProps) {
  const [fetch, setFetch] = useState(false);
  const [downloadSuccessModal, setDownloadSuccessModal] = useState(false);

  const { response, loading, error } = useApi({
    method: "get",
    url: fetch ? `uplus2/regcode?state=2` : undefined,
  });

  useEffect(() => {
    if (response?.status === 200) {
      if (response?.data?.list?.length > 0) {
        const styleList: string[][] = [];

        response?.data?.list?.forEach((l: any, i: number) => {
          styleList.push([
            `${i + 1}`,
            "Change",
            l?.code,
            l?.phone,
            l?.name,
            l?.birth,
            "N",
          ]);
        });

        exportJsonToExcelStyle(
          "유플러스 결합 대기자 리스트",
          undefined,
          "1. 아래 리스트에 있는 고객들 중 결합 완료자만을 선별해 주세요.\n2. 결합 완료자의 고객 정보를 '데이터 업로드 양식'에 복사 붙여넣기 한 뒤, Type: Change / 결합여부: Y로 입력해 주세요.\n※ 데이터 업로드 양식은 링키드 어드민 -> 유플러스 결합 -> 데이터 업로드를 통해 다운로드 받을 수 있어요. (해당 파일과는 다른 파일입니다.)",
          ["Index", "Type", "Code", "Phone", "Name", "Birth", "Combined"],
          "링키드_유플러스_결합대기자리스트",
          "Export",
          styleList,
          undefined,
          undefined,
          undefined
        );

        setDownloadSuccessModal(true);
      } else {
        toast.error("결합 대기자가 없습니다.");
        closeEvent();
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "결합 대기자 다운로드에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <AlertModal
        title="결합 대기자 다운로드"
        desc={`${dayjs().format(
          "YYYY-MM-DD"
        )} 기준\n결합 대기자 리스트를 다운로드 하시겠어요?`}
        cancelEvent={closeEvent}
        confirmText="다운로드"
        confirmEvent={() => setFetch(true)}
      />

      {loading && <Loader />}

      {downloadSuccessModal && (
        <AlertModal
          title={`결합 대기자 리스트 다운로드 완료`}
          desc={`${getThousandComma(response?.data?.list?.length)}건 다운로드`}
          customCancelBtn={<></>}
          btnColor="mint"
          confirmEvent={() => {
            setDownloadSuccessModal(false);
            closeEvent();
          }}
        />
      )}
    </>
  );
}
